import React, { useContext, useEffect, useState } from "react";
import styles from "./ThemeToggle.module.css";
import { ThemeContext } from "../context/ThemeContext";
import { Moon, Sun } from "lucide-react";

const ThemeToggle: React.FC<{ mobile?: boolean }> = ({ mobile = false }) => {
  const { theme, toggleTheme, hasUserToggled, setUserToggled } = useContext(ThemeContext);
  const isDark = theme === "dark";
  const [showHint, setShowHint] = useState(false);

  useEffect(() => {
    if (!isDark && !hasUserToggled) {
      setShowHint(true);
      const timer = setTimeout(() => setShowHint(false), 5600); 
      return () => clearTimeout(timer);
    }
  }, [isDark, hasUserToggled]);

  const handleClick = () => {
    toggleTheme();
    setUserToggled();
    setShowHint(false);
  };

  return (
    <div
      className={mobile ? styles.mobileThemeToggle : styles.linkToggle}
      onClick={handleClick}
    >
      <span className={styles.icon}>
        {isDark ? <Moon size={18} /> : <Sun size={18} />}
      </span>
      <span className={styles.modeLabel}>
        {isDark ? "Ansicht" : "Ansicht"}
      </span>
      <div className={`${styles.slider} ${showHint ? styles.sliderAnimate : ""}`}>
        <div
          className={`${styles.thumb} ${isDark ? styles.thumbRight : ""} ${
            showHint ? styles.thumbAuto : ""
          }`}
        />
      </div>
    </div>
  );
};

export default ThemeToggle;